import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CarouselModule } from "ngx-owl-carousel-o";
import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavbarComponent } from "./components/layouts/navbar/navbar.component";
import { PreloaderComponent } from "./components/layouts/preloader/preloader.component";
import { HomeOneComponent } from "./components/pages/home-one/home-one.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { ButtonHoverDirective } from "./directives/button-hover.directive";

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        PreloaderComponent,
        HomeOneComponent,
        FooterComponent,
        ButtonHoverDirective,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CarouselModule,
        TranslateModule.forRoot({
            fallbackLang: "en",
        }),
    ],
    providers: [
        ...provideTranslateHttpLoader({
            prefix: "/assets/i18n/",
            suffix: ".json",
        }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
